import React from "react";
import Layout from "./shared/Layout";
import classes from './assets/css/Contact.module.css';

const Contact = () => {
  return (
    <Layout>
      <div className="contact text-center py-5">
        <h1>Get In Touch</h1>
        <p className={classes.contact_text}>My inbox is always open as I am looking for new opportunities. I am very much interested in freelance opportunities as well as full-time opportunities - especially ambitious or large projects. However, if you have other request or question, don't hesitate to contact me.</p>
        <div className={classes.contact_me}>
        <a href="mailto:mosesjoshua350@gmail.com" className={`contact-link ${classes.contact_link}`}>Contact Me</a>
        </div>
       
      </div>
    </Layout>
  );
};

export default Contact;